//
// Home Button

homeButton = {};

homeButton.create = function () {
  var button = new PIXI.Container();

  var hasHomeButton = gdk.hasHomeButton();

  InputHelpers.addGenerics(button);

  button.canEnable = function () {
    return hasHomeButton;
    //return (bowser.mobile && (this._homeData.URL !== ""));
  };

  button.canShow = function () {
    return hasHomeButton;
    //return (bowser.mobile && (this._homeData.URL !== ""));
  };

  button.disableButton = function () {
    return; // not today!
  };

  /*	button.parseGameConfig = function(gameConfigTask) {
		if (gameConfigTask.data.showHomeButton === true) {
			this._homeData.URL = gameConfigTask.data.homeURL;
		}
	};
*/
  button.onPressedCallback = function () {
    //resourceManager.getController("inputOverlord").setState("disabled");
    //window.open(this._homeData.URL, "_top");
    gdk.goHome();
    if (button.soundName !== "") button.playSound();
  };

  //	messageBus.subscribe("spinner:GameConfigEvent", button.parseGameConfig.bind(button));

  return button;
};

homeButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
homeButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "homeButton",
  homeButton.create,
  homeButton.initialise,
  homeButton.getFilesRequired
);
